import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _HotSpotEdit;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import pick from 'lodash/fp/pick';
import find from 'lodash/fp/find';
import { Text } from '@instructure/ui-text';
import { Alert } from '@instructure/ui-alerts';
import { Button, IconButton } from '@instructure/ui-buttons';
import { IconBoxLine, IconEmptyLine, IconInfoLine, IconMarkerLine, IconQuestionLine } from '@instructure/ui-icons';
import { View } from '@instructure/ui-view';
import { jsx } from '@instructure/emotion';
import { SimpleModal, withStyleOverrides, FormFieldGroup } from '@instructure/quiz-common';
import HotSpotInteractionType from '../../../records/interactions/hotspot';
import QuestionSettingsContainer from '../../common/edit/components/QuestionSettingsContainer';
import QuestionContainer from '../../common/edit/components/QuestionContainer';
import RemoveChoiceButton from '../../common/edit/components/RemoveChoiceButton';
import DrawingContainer from './DrawingContainer';
import Oval from '../common/Oval';
import Polygon from '../common/Polygon';
import Square from '../common/Square';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import withEditTools from '../../../util/withEditTools';
import t from '@instructure/quiz-i18n/es/format-message';
import QuestionSettingsPanel from '../../common/edit/components/QuestionSettingsPanel';
import CalculatorOptionWithOqaatAlert from '../../common/edit/components/CalculatorOptionWithOqaatAlert';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { RadioInputGroup, RadioInput } from '@instructure/ui-radio-input';
import castArray from 'lodash/castArray';
export function drawTypes() {
  return [{
    type: 'square',
    title: t('Square'),
    icon: IconBoxLine,
    component: Square
  }, {
    type: 'oval',
    title: t('Oval'),
    icon: IconEmptyLine,
    component: Oval
  }, {
    type: 'polygon',
    title: t('Polygon'),
    icon: IconMarkerLine,
    component: Polygon
  }];
}
var ALL_OR_NOTHING = 'AllOrNothing';

/**
---
category: HotSpot
---
  HotSpot Edit component

   ```jsx_example
   function Example (props) {
    const exampleProps = {
      itemBody: 'Which of these players is David Ferrer',
      interactionData: {
        imageUrl: 'https://i.ytimg.com/vi/LgkAebhJ7iE/maxresdefault.jpg'
      },
      scoringData: {
        value: {
          type: 'oval',
          coordinates: [
            { x: 0.6, y: 0.13 },
            { x: 0.7, y: 0.2 }
          ]
        }
      }
    }

    return (
      <HotSpotEdit {...exampleProps} {...props} />
    )
  }

  <SettingsSwitcher locales={LOCALES}>
    <EditStateProvider>
      <Example />
    </EditStateProvider>
  </SettingsSwitcher>
  ```
**/
var HotSpotEdit = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), withEditTools(_class = _dec(_class = (_HotSpotEdit = /*#__PURE__*/function (_Component) {
  function HotSpotEdit() {
    var _this;
    _classCallCheck(this, HotSpotEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HotSpotEdit, [].concat(args));
    _defineProperty(_this, "drawingContainer", null);
    _defineProperty(_this, "state", {
      file: null,
      isShortcutsModalOpen: false,
      currentId: null,
      currentShapeType: 'square',
      tempHotspot: null,
      isModalOpen: false,
      canvasRef: null
    });
    _defineProperty(_this, "handleCanvasRef", function (ref) {
      _this.setState({
        canvasRef: ref
      });
    });
    // ===========
    //   HELPERS
    // ===========
    _defineProperty(_this, "updateProps", function (newProps) {
      var propsToUpdate = pick(['interactionData', 'scoringData', 'properties'], _this.props);
      _this.props.changeItemState(update(propsToUpdate, newProps));
    });
    _defineProperty(_this, "getConvertedCoordinates", function (coordinatesArray) {
      return coordinatesArray.map(function (_ref) {
        var x = _ref.x,
          y = _ref.y;
        return {
          x: x / _this.drawingContainer.currentImageWidth(),
          y: y / _this.drawingContainer.currentImageHeight()
        };
      });
    });
    _defineProperty(_this, "addNewHotspot", function (convertedCoordinates) {
      _this.updateProps({
        interactionData: {
          hotspotsCount: {
            $set: _this.props.scoringData.value.length + 1
          }
        },
        scoringData: {
          value: {
            $push: [_objectSpread(_objectSpread({}, _this.state.tempHotspot), {}, {
              coordinates: convertedCoordinates
            })]
          }
        }
      });
      _this.setState({
        tempHotspot: null,
        currentId: _this.state.tempHotspot.id
      });
    });
    _defineProperty(_this, "updateExistingHotspot", function (lastHotspotIndex, convertedCoordinates) {
      _this.updateProps({
        scoringData: {
          value: _defineProperty({}, lastHotspotIndex, {
            coordinates: {
              $set: convertedCoordinates
            }
          })
        }
      });
    });
    _defineProperty(_this, "finalizeHotspot", function (lastHotspotIndex, convertedCoordinates) {
      _this.updateProps({
        interactionData: {
          hotspotsCount: {
            $set: _this.props.scoringData.value.length
          }
        },
        scoringData: {
          value: _defineProperty({}, lastHotspotIndex, {
            coordinates: {
              $set: convertedCoordinates
            }
          })
        }
      });
    });
    _defineProperty(_this, "prepareNewTempHotspot", function () {
      var newId = _this.props.scoringData.value.length + 1;
      _this.setState({
        tempHotspot: {
          type: _this.state.currentShapeType,
          coordinates: [],
          id: newId
        }
      });
    });
    _defineProperty(_this, "convertCoordinates", function (coordinatesArray, isDrawing) {
      var isKeyboard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var convertedCoordinates = _this.getConvertedCoordinates(coordinatesArray);
      if (!_this.props.multipleHotSpotEnabled) {
        _this.updateProps({
          scoringData: {
            value: {
              coordinates: {
                $set: convertedCoordinates
              }
            }
          }
        });
        return;
      }
      var value = _this.props.scoringData.value;
      var hotspots = castArray(value);
      var lastHotspotIndex = hotspots === null || hotspots === void 0 ? void 0 : hotspots.findIndex(function (hotspot) {
        return (hotspot === null || hotspot === void 0 ? void 0 : hotspot.id) === _this.state.currentId;
      });
      if (isDrawing) {
        if (_this.state.tempHotspot && !isKeyboard) {
          _this.addNewHotspot(convertedCoordinates);
        } else {
          _this.updateExistingHotspot(lastHotspotIndex, convertedCoordinates);
        }
      } else {
        _this.finalizeHotspot(lastHotspotIndex, convertedCoordinates);
        _this.prepareNewTempHotspot();
      }
    });
    // ===========
    //   HANDLERS
    // ===========
    _defineProperty(_this, "handleCalculatorTypeChange", function (e, value) {
      _this.props.changeItemState({
        calculatorType: value
      });
    });
    _defineProperty(_this, "handleTypeChange", function (newType) {
      var _lastHotspot$coordina;
      var coordinates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!_this.props.multipleHotSpotEnabled) {
        _this.updateProps({
          scoringData: {
            value: {
              $set: {
                type: newType,
                coordinates: coordinates || []
              }
            }
          }
        });
        _this.setState({
          currentShapeType: newType,
          tempHotspot: null
        });
        return;
      }
      var value = _this.props.scoringData.value;
      var hotspots = castArray(value);
      var lastHotspotIndex = hotspots === null || hotspots === void 0 ? void 0 : hotspots.findIndex(function (hotspot) {
        return (hotspot === null || hotspot === void 0 ? void 0 : hotspot.id) === _this.state.currentId;
      });
      var lastHotspot = hotspots[lastHotspotIndex];
      if ((lastHotspot === null || lastHotspot === void 0 || (_lastHotspot$coordina = lastHotspot.coordinates) === null || _lastHotspot$coordina === void 0 ? void 0 : _lastHotspot$coordina.length) > 0 || !_this.state.currentId) {
        // Generate the next available sequential ID based on the current number of hotspots
        var newId = hotspots.length + 1;
        var tempHotspot = {
          type: newType,
          coordinates: [],
          id: newId
        };
        _this.setState({
          currentShapeType: newType,
          tempHotspot: tempHotspot
        });
      } else {
        _this.updateProps({
          scoringData: {
            value: _defineProperty({}, lastHotspotIndex, {
              type: {
                $set: newType
              } // Only update the type of the existing hotspot
            })
          }
        });
        _this.setState({
          currentShapeType: newType,
          tempHotspot: null
        });
      }
    });
    _defineProperty(_this, "handleRemoveImage", function () {
      _this.updateProps({
        interactionData: {
          $set: {}
        },
        scoringData: {
          value: {
            $set: []
          }
        }
      });
    });
    _defineProperty(_this, "handleUpload", function (url) {
      var hotSpot = {
        type: 'square',
        coordinates: [],
        id: 1
      };
      _this.updateProps({
        interactionData: {
          imageUrl: {
            $set: url
          },
          hotspotsCount: {
            $set: 0
          }
        },
        scoringData: {
          value: {
            $set: !_this.props.multipleHotSpotEnabled ? hotSpot : [hotSpot]
          }
        }
      });
      _this.setState({
        tempHotspot: null,
        currentId: 1,
        file: null,
        currentShapeType: 'square'
      });
    });
    _defineProperty(_this, "openShortcutsModal", function () {
      _this.setState({
        isShortcutsModalOpen: true
      });
    });
    _defineProperty(_this, "closeShortcutsModal", function () {
      _this.setState({
        isShortcutsModalOpen: false
      });
    });
    _defineProperty(_this, "handleDropAccepted", function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        file = _ref3[0];
      if (file instanceof Blob) {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.setState({
            file: {
              url: e.target.result
            }
          });
        };
        reader.readAsDataURL(file);
      }
      _this.setState({
        file: {}
      });
      _this.props.mediaUpload(file, _this.handleUpload);
    });
    _defineProperty(_this, "handleDrawingRemove", function (hotspotId) {
      if (!_this.props.multipleHotSpotEnabled) {
        var _this$props$scoringDa;
        _this.drawingContainer.canvas.clearCanvas();
        _this.drawingContainer.canvas.focus();
        _this.handleTypeChange(((_this$props$scoringDa = _this.props.scoringData) === null || _this$props$scoringDa === void 0 || (_this$props$scoringDa = _this$props$scoringDa.value) === null || _this$props$scoringDa === void 0 ? void 0 : _this$props$scoringDa.type) || _this.state.currentShapeType);
        return;
      }
      var indexToRemove = _this.props.scoringData.value.findIndex(function (hotspot) {
        return hotspot.id === hotspotId;
      });
      if (indexToRemove !== -1 && _this.props.scoringData.value.length > 1) {
        var updatedHotspots = update(_this.props.scoringData.value, {
          $splice: [[indexToRemove, 1]]
        });
        // Reassign IDs sequentially
        var reorderedHotspots = updatedHotspots.map(function (hotspot, idx) {
          return _objectSpread(_objectSpread({}, hotspot), {}, {
            id: idx + 1 // Reassign sequential ID
          });
        });
        _this.updateProps({
          interactionData: {
            hotspotsCount: {
              $set: reorderedHotspots.length
            }
          },
          scoringData: {
            value: {
              $set: reorderedHotspots
            }
          }
        });
        var newCurrentId = reorderedHotspots.length > 0 ? reorderedHotspots[0].id : null;
        _this.setState({
          currentId: newCurrentId,
          tempHotspot: {
            type: _this.state.currentShapeType,
            coordinates: [],
            id: reorderedHotspots.length + 1
          }
        });
      } else {
        _this.updateProps({
          interactionData: {
            hotspotsCount: {
              $set: 1
            }
          },
          scoringData: {
            value: _defineProperty({}, indexToRemove, {
              coordinates: {
                $set: []
              },
              type: {
                $set: _this.state.currentShapeType || 'square'
              }
            })
          }
        });
        _this.setState({
          currentId: 1,
          tempHotspot: null
        });
      }
    });
    _defineProperty(_this, "handleDescriptionChange", function (itemBody) {
      return _this.props.changeItemState({
        itemBody: itemBody
      });
    });
    _defineProperty(_this, "handleDrawingContainerRef", function (node) {
      _this.drawingContainer = node;
    });
    _defineProperty(_this, "handleCloseModal", function () {
      _this.setState({
        isModalOpen: false
      });
    });
    _defineProperty(_this, "handleOpenModal", function () {
      _this.setState({
        isModalOpen: true
      });
    });
    return _this;
  }
  _inherits(HotSpotEdit, _Component);
  return _createClass(HotSpotEdit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        interactionData = _this$props.interactionData,
        multipleHotSpotEnabled = _this$props.multipleHotSpotEnabled,
        scoringData = _this$props.scoringData;
      if (interactionData !== null && interactionData !== void 0 && interactionData.imageUrl) {
        if (multipleHotSpotEnabled) {
          this.handleTypeChange(this.state.currentShapeType);
        } else {
          var _scoringData$value;
          this.setState({
            currentShapeType: (scoringData === null || scoringData === void 0 || (_scoringData$value = scoringData.value) === null || _scoringData$value === void 0 ? void 0 : _scoringData$value.type) || 'square'
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var multipleHotSpotEnabled = this.props.multipleHotSpotEnabled;
      if (multipleHotSpotEnabled) {
        this.ensureScoringDataIsArray();
      } else {
        this.handleSingleHotSpotUpdate();
      }
    }
  }, {
    key: "ensureScoringDataIsArray",
    value: function ensureScoringDataIsArray() {
      var scoringData = this.props.scoringData;
      if (scoringData !== null && scoringData !== void 0 && scoringData.value && !Array.isArray(scoringData.value)) {
        var normalizedValue = [_objectSpread(_objectSpread({}, scoringData.value), {}, {
          id: 1
        })];
        this.updateProps({
          scoringData: {
            value: {
              $set: normalizedValue
            }
          }
        });
      }
    }
  }, {
    key: "handleSingleHotSpotUpdate",
    value: function handleSingleHotSpotUpdate() {
      var _scoringData$value2, _scoringData$value4;
      var scoringData = this.props.scoringData;
      if ((scoringData === null || scoringData === void 0 || (_scoringData$value2 = scoringData.value) === null || _scoringData$value2 === void 0 ? void 0 : _scoringData$value2.length) === 1) {
        var _scoringData$value3 = _slicedToArray(scoringData.value, 1),
          hotSpot = _scoringData$value3[0];
        this.handleTypeChange(hotSpot.type, hotSpot.coordinates);
      } else if ((scoringData === null || scoringData === void 0 || (_scoringData$value4 = scoringData.value) === null || _scoringData$value4 === void 0 ? void 0 : _scoringData$value4.length) > 1) {
        this.handleDrawingRemove();
      }
    }
  }, {
    key: "renderFooter",
    value:
    // ===========
    //   RENDER
    // ===========

    function renderFooter() {
      var _this2 = this;
      var value = this.props.scoringData.value;
      var url = this.props.interactionData.imageUrl;
      var hotspots = castArray(value);
      if (url && hotspots.length > 0) {
        return jsx(React.Fragment, null, hotspots.map(function (hotspot) {
          var _find = find({
              type: hotspot.type
            }, drawTypes()),
            title = _find.title;
          var mainText = t('{title} Hot Spot', {
            title: title
          });
          if (hotspot.coordinates.length < 2) {
            return null;
          }
          return jsx("div", {
            key: hotspot.id,
            css: _this2.props.styles.footerContainer
          }, jsx("div", {
            css: _this2.props.styles.footerContainerText
          }, jsx("div", null, jsx(Text, {
            weight: "bold"
          }, mainText)), jsx("div", null, jsx(Text, {
            color: "primary"
          }, t('Clicks within the hot spot will be considered correct')))), jsx(RemoveChoiceButton, {
            onRemoveChoice: function onRemoveChoice() {
              return _this2.handleDrawingRemove(hotspot.id);
            },
            screenReaderText: t('Remove Drawing'),
            automationData: "sdk-remove-hotspot-area-button"
          }));
        }));
      }
      return null;
    }
  }, {
    key: "renderOptionsDescription",
    value: function renderOptionsDescription() {
      return jsx(ScreenReaderContent, null, t('Hotspot options'));
    }
  }, {
    key: "renderShortcutsModal",
    value: function renderShortcutsModal() {
      return jsx(SimpleModal, {
        footerContent: jsx(Button, {
          onClick: this.closeShortcutsModal,
          color: "primary"
        }, t('Close')),
        isModalOpen: this.state.isShortcutsModalOpen,
        onModalDismiss: this.closeShortcutsModal,
        size: "medium",
        title: t('Hotspot Controls & Shortcuts'),
        label: t('Hotspot Controls & Shortcuts')
      }, jsx("div", {
        css: this.props.styles.modalContent
      }, jsx(Text, null, t('Hotspot Controls')), jsx("ul", null, jsx("li", null, t('Use the Arrow keys to move the hotspot')), jsx("li", null, t('Hold Shift and use the Arrow keys to resize the hotspot')), jsx("li", null, t('Hold Shift + Alt and use the Arrow keys to shrink the hotspot')), jsx("li", null, t('Press the Escape key to close the modal'))), jsx(Text, null, t('Shortcuts')), jsx("ul", null, jsx("li", null, t('F: Expand Image')), jsx("li", null, t('D: Remove Image')), jsx("li", null, t('B: Browse for Image')), jsx("li", null, t('I: Open Shortcuts Modal')), jsx("li", null, t('C or ESC: Close Shortcuts Modal')), jsx("li", null, t('R: Add Square Hotspot')), jsx("li", null, t('O: Add Oval Hotspot')), jsx("li", null, t('P: Draw Polygon Hotspot')), jsx("li", null, t('E: Close Polygon Shape')), jsx("li", null, t('Delete or Backspace: Remove Current Hotspot')), jsx("li", null, t('Enter: Add Polygon Point')))));
    }

    // these are added for a way to let the user know that the current supported grading options is exact match
    // as partial grading is to be added in the future
  }, {
    key: "renderGradingOptionsModal",
    value: function renderGradingOptionsModal() {
      return jsx(SimpleModal, {
        size: "small",
        title: t('Grading'),
        label: t('Grading'),
        isModalOpen: this.state.isModalOpen,
        onModalDismiss: this.handleCloseModal,
        "data-automation": "sdk-hotspot-grading-options"
      }, jsx(Text, {
        weight: "bold",
        lineHeight: "double"
      }, t('Exact match')), jsx("br", null), jsx(Text, null, t('Students are awarded full credit if all correct answers are selected and no incorrect answers are selected.')));
    }
  }, {
    key: "renderGradingOptions",
    value: function renderGradingOptions() {
      var value = this.props.scoringData.value;
      var hotspots = castArray(value);
      var eligibleHotspots = hotspots.filter(function (hotspot) {
        var _hotspot$coordinates;
        return (hotspot === null || hotspot === void 0 || (_hotspot$coordinates = hotspot.coordinates) === null || _hotspot$coordinates === void 0 ? void 0 : _hotspot$coordinates.length) > 1;
      });
      if (eligibleHotspots.length < 2) return null;
      return jsx(View, {
        as: "div",
        margin: "medium 0",
        position: "relative"
      }, jsx(RadioInputGroup, {
        onChange: function onChange() {},
        name: t('Grading'),
        value: ALL_OR_NOTHING,
        description: jsx("span", null, t('Grading'), jsx(IconButton, {
          size: "small",
          withBackground: false,
          withBorder: false,
          renderIcon: IconQuestionLine,
          onClick: this.handleOpenModal,
          screenReaderLabel: t('Open grading option information')
        }))
      }, jsx(RadioInput, {
        value: ALL_OR_NOTHING,
        label: t('Exact Match'),
        "data-automation": "sdk-hotspot-exact"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var hotspots = castArray(this.props.scoringData.value);
      var canvasErrors = this.props.multipleHotSpotEnabled ? 'scoringData.value[0].coordinates' : 'scoringData.value.coordinates';
      var typeErrors = this.props.multipleHotSpotEnabled ? 'scoringData.value[0].type' : 'scoringData.value.type';
      return jsx("div", null, jsx("div", {
        className: "accessibilityInfo",
        css: this.props.styles.accessibilityInfo
      }, jsx(Text, {
        color: "secondary"
      }, jsx(IconInfoLine, {
        size: "x-small",
        css: this.props.styles.accessibilityInfoIcon
      }), t('This question type is not accessible to users requiring screen readers.'))), jsx(Alert, {
        variant: "info"
      }, jsx(Text, {
        id: "hotspot-oqaat-info"
      }, t.rich("Keyboard controls are available while using the hotspot. Click<0>here</0> or press <1>i</1> for a list of shortcuts.\n              Just make sure no input field is focused to use these controls.", [function (_ref4) {
        var children = _ref4.children;
        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          jsx("span", {
            key: "1",
            role: "button",
            tabIndex: "0",
            css: _this3.props.styles.keyboardControlsList,
            onClick: _this3.openShortcutsModal
          }, children)
        );
      }, function (_ref5) {
        var children = _ref5.children;
        return jsx("strong", {
          key: "2"
        }, children);
      }]))), jsx(QuestionContainer, {
        disabled: this.props.overrideEditableForRegrading,
        enableRichContentEditor: this.props.enableRichContentEditor,
        itemBody: this.props.itemBody,
        onDescriptionChange: this.handleDescriptionChange,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        openImportModal: this.props.openImportModal,
        stemErrors: this.props.getErrors('itemBody')
      }, jsx(DrawingContainer, {
        ref: this.handleDrawingContainerRef,
        canvasErrors: this.props.getErrors(canvasErrors),
        hotspots: hotspots,
        currentType: this.state.currentShapeType,
        drawTypes: drawTypes(),
        fileDropErrors: this.props.getErrors('interactionData.imageUrl'),
        onModalOpen: this.props.onModalOpen,
        onModalClose: this.props.onModalClose,
        onDropAccepted: this.handleDropAccepted,
        onSetType: this.handleTypeChange,
        convertCoordinates: this.convertCoordinates,
        onRemoveImage: this.handleRemoveImage,
        typeErrors: this.props.getErrors(typeErrors),
        url: this.props.interactionData.imageUrl || this.state.file && this.state.file.url,
        isUploading: this.state.file !== null,
        onRemoveHotspot: this.handleDrawingRemove,
        onOpenShortcutsModal: this.openShortcutsModal,
        onCloseShortcutsModal: this.closeShortcutsModal,
        isShortcutsModalOpen: this.state.isShortcutsModalOpen,
        tempHotspot: this.state.tempHotspot,
        currentHotspotId: this.state.currentId,
        setCanvasRef: this.handleCanvasRef,
        canvasRef: this.state.canvasRef,
        multipleHotSpotEnabled: this.props.multipleHotSpotEnabled
      }), this.renderFooter()), jsx(QuestionSettingsContainer, {
        additionalOptions: this.props.additionalOptions
      }, jsx(QuestionSettingsPanel, {
        label: t('Options'),
        defaultExpanded: true
      }, jsx(FormFieldGroup, {
        rowSpacing: "small",
        description: this.renderOptionsDescription()
      }, jsx(CalculatorOptionWithOqaatAlert, {
        disabled: this.props.overrideEditableForRegrading,
        calculatorValue: this.props.calculatorType,
        onCalculatorTypeChange: this.handleCalculatorTypeChange,
        oqaatChecked: this.props.oneQuestionAtATime,
        onOqaatChange: this.props.setOneQuestionAtATime
      })))), this.state.isShortcutsModalOpen && this.renderShortcutsModal(), this.renderGradingOptionsModal());
    }
  }]);
}(Component), _defineProperty(_HotSpotEdit, "displayName", 'HotSpotEdit'), _defineProperty(_HotSpotEdit, "componentId", "Quizzes".concat(_HotSpotEdit.displayName)), _defineProperty(_HotSpotEdit, "interactionType", HotSpotInteractionType), _defineProperty(_HotSpotEdit, "propTypes", _objectSpread(_objectSpread({
  additionalOptions: PropTypes.array,
  calculatorType: PropTypes.string,
  changeItemState: PropTypes.func.isRequired,
  enableRichContentEditor: PropTypes.bool,
  errors: PropTypes.shape({
    itemBody: PropTypes.arrayOf(PropTypes.string),
    interactionData: PropTypes.shape({
      imageUrl: PropTypes.arrayOf(PropTypes.string)
    }),
    scoringData: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.arrayOf(PropTypes.string),
        coordinates: PropTypes.arrayOf(PropTypes.string)
      }))
    })
  }),
  interactionData: PropTypes.shape({
    imageUrl: PropTypes.string,
    hotspotsCount: PropTypes.number
  }).isRequired,
  itemBody: PropTypes.string,
  mediaUpload: PropTypes.func.isRequired,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  oneQuestionAtATime: PropTypes.bool,
  openImportModal: PropTypes.func,
  overrideEditableForRegrading: PropTypes.bool,
  scoringData: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.oneOf(['square', 'oval', 'polygon']),
      coordinates: PropTypes.arrayOf(PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
      }))
    })).isRequired
  }).isRequired,
  setOneQuestionAtATime: PropTypes.func
}, withEditTools.injectedProps), {}, {
  styles: PropTypes.object,
  multipleHotSpotEnabled: PropTypes.bool
})), _defineProperty(_HotSpotEdit, "defaultProps", {
  calculatorType: 'none',
  enableRichContentEditor: true,
  oneQuestionAtATime: false,
  overrideEditableForRegrading: false,
  setOneQuestionAtATime: Function.prototype,
  additionalOptions: void 0,
  errors: void 0,
  itemBody: void 0,
  onModalClose: void 0,
  onModalOpen: void 0,
  openImportModal: void 0,
  multipleHotSpotEnabled: false
}), _HotSpotEdit)) || _class) || _class);
export { HotSpotEdit as default };